export * from './register-teacher';
